/**
 * Client du consentement parental (RGPD art.8) — appelle l'edge fn
 * `parental-consent-request` (JWT élève) pour (r)envoyer le mail au parent.
 */

import { supabase, supabaseUrl, supabaseAnonKey } from '@/lib/supabase';

export interface ConsentRequestResult {
  ok: boolean;
  email_sent: boolean;
  already_active?: boolean;
}

/**
 * (Re)demande l'accord parental : régénère le lien magique et envoie le mail.
 * `parentEmail` omis ⇒ l'edge fn réutilise l'adresse déjà enregistrée.
 */
export async function requestParentalConsent(parentEmail?: string): Promise<ConsentRequestResult> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error('no_session');

  const res = await fetch(`${supabaseUrl}/functions/v1/parental-consent-request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: supabaseAnonKey,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(parentEmail ? { parent_email: parentEmail } : {}),
  });

  if (!res.ok) {
    let reason = 'request_failed';
    try {
      reason = ((await res.json()) as { error?: string }).error ?? reason;
    } catch {
      /* corps non-JSON */
    }
    throw new Error(reason);
  }
  return (await res.json()) as ConsentRequestResult;
}
